module.exports = __webpack_public_path__ + "fd62799c1d121be530a0cb5850ffe6ec.eot";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-semibold-italic.eot
// module id = 22
// module chunks = 0